export const search_field = (search) => ({
  type: 'search_field',
  payload: search,
});

export const open_search = (open) => ({
  type: 'open_search',
  payload: open,
});
